import React from 'react';
import PaletteIcon from '@images/palette-icon.svg';

const IconTheme = () => (
  <img
    src={PaletteIcon}
    alt="Color Palette"
    title="Color Palette"
    style={{
      width: '20px',
      height: '20px',
      objectFit: 'contain',
      display: 'block',
      filter: 'brightness(0) saturate(0%) invert(70%)',
      transition: 'transform 0.3s ease',
    }}
  />
);

export default IconTheme;
